import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useWizard } from "../../../wizard/context";
import { INote } from "../../types";
import { useApplicationConfig } from "../../modals/hooks/useApplicationConfig";

const useStyles = makeStyles(() => ({
  note: {
    color: "#2F80ED",
    fontSize: 12,
    fontWeight: "bold",
    lineHeight: "normal",
    "&:hover": {
      color: "#276ac7",
      cursor: "pointer",
    },
  },
}));

interface INoteProps {
  note: INote;
}

export const Note: FC<INoteProps> = ({ note }) => {
  const classes = useStyles();

  const { openWizard } = useWizard();
  const { getNoteConfig } = useApplicationConfig();

  return (
    <span
      className={classes.note}
      onClick={() => openWizard(getNoteConfig(note))}
    >
      Note
    </span>
  );
};
